var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5165_366699",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#FFD700"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5165_366699)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#FFD700"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5165_366699",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 2,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99905 9.60249C7.80272 9.60249 7.6389 9.45255 7.62155 9.25699L7.242 4.97838C7.20234 4.53133 7.55456 4.14648 8.00336 4.14648C8.45277 4.14648 8.80519 4.53233 8.76459 4.9799L8.37648 9.25775C8.35876 9.45298 8.19508 9.60249 7.99905 9.60249ZM8.0042 12.0885C7.77687 12.0885 7.58253 12.0262 7.4212 11.9015C7.25987 11.7768 7.1792 11.5605 7.1792 11.2525C7.1792 10.9372 7.25987 10.7208 7.4212 10.6035C7.58253 10.4862 7.77687 10.4275 8.0042 10.4275C8.2242 10.4275 8.41487 10.4862 8.5762 10.6035C8.74487 10.7208 8.8292 10.9372 8.8292 11.2525C8.8292 11.5678 8.74487 11.7878 8.5762 11.9125C8.41487 12.0298 8.2242 12.0885 8.0042 12.0885Z",
    fill: "#B36200"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5165_366699)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#B36200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warning-alert.327f79966db9a3b9663fe2bb2843c2a4.svg";
export { ForwardRef as ReactComponent };